import React from 'react';
import { Typography, Box, useTheme } from '@mui/material';

const NoDealsFoundMessage = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        padding: { xs: 2, sm: 3 }, // Responsive padding
        margin: { xs: '20px 10px', sm: '20px auto' }, // Responsive margin
        maxWidth: '600px', // Limit width for better readability
        backgroundColor: theme.palette.background.paper, // Adapts to dark/light mode
        borderRadius: 2, // Rounded corners
        boxShadow: theme.shadows[1], // Subtle shadow
        border: `1px solid ${theme.palette.divider}` // Border for contrast
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: theme.palette.text.primary,
          fontWeight: 'bold',
          mb: 1 // Margin bottom for spacing
        }}
      >
        No Deals Found
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.text.secondary,
          fontSize: { xs: '0.9rem', sm: '1rem' } // Responsive font size
        }}
      >
        Try scrolling down to load the next list of deals!
      </Typography>
    </Box>
  );
};

export default NoDealsFoundMessage;
